import React from 'react';

const Erfahrungen = () => {

    return (
        <>
            <section className="resume-section" id="experience">
                <div className="resume-section-content">
                    <h2 className="mb-5 text-primary">Erfahrungen</h2>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Mitarbeiter für soziale Beratung</h3>
                            <div className="subheading mb-3">Pandechaion – Herberge e.V, Leipzig</div>
                            <ul>
                                <li>Unterstützung der Sozialbetreuung</li>
                                <li>Beratung zu den Themen Asyl und Administration in Deutschland</li>
                                <li>Unterrichten von Sprachkursen</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(10/2018 - 03/2019)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Computertechniker & Lehrer</h3>
                            <div className="subheading mb-3">Echo100plus (NGO), Leros, Griechenland</div>
                            <ul>
                                <li>Vorbereitung und Durchführung von Kursen zum
                                    Computermanagement für Bewohner der Insel Leros</li>
                                <li>Bereitstellung von technischer Unterstützung für Echo100plus</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(03/2017 - 06/2017)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Begründer und Eigentümer eines Computer- und Mobiltelefonladens</h3>
                            <div className="subheading mb-3">Icon Zentrum, Damaskus, Syrien</div>
                            <ul>
                                <li>Verkauf: Kundenberatung und -betreuung sowie Marketing</li>
                                <li>Technik: Reparaturen und Verbesserungen von Computern und
                                    Mobiltelefonen</li>
                                <li>Administration: Mitarbeitermanagement eines fünfköpfigen Teams, Rechnungswesen und
                                    Buchführung</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(08/2006 – 05/2016)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Direktor automatischer Signalsysteme</h3>
                            <div className="subheading mb-3">Ministerium für Elektrizität, Damaskus, Syrien</div>
                            <ul>
                                <li>Überwachung der Elektrizitätsablesungen in Damaskus und
                                    Analyse der Daten, Qualitätssicherung und Weiterleitung der
                                    Ergebnisse zum Rechnungssystem des Ministeriums</li>
                                <li>Management eines neunköpfigen Teams und Weiterleitung
                                    externer Daten an ein Team von 90 Mitarbeitern</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(09/2011 – 05/2016)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Supervisor der Wartungsabteilung</h3>
                            <div className="subheading mb-3">Firma Modern Building Contracting, Dubai, VAE</div>
                            <ul>
                                <li>Management und Kontrolle der elektrischen Operationssysteme
                                    aller firmenbezogenen Standorte in den VAE</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(11/2008 – 09/2009)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Computer-Systemdesigner in Teilzeit</h3>
                            <div className="subheading mb-3">Light Angel Trading, Damaskus, Syrien</div>
                            <ul>
                                <li>Schaffung und Wahrung von Zuliefererkontakten, Kundenberatung
                                    als Computer-Systemdesigner</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(09/2004 – 02/2011)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Technischer Assistent in Teilzeit</h3>
                            <div className="subheading mb-3">Firma Alhakeim, Damaskus, Syrien</div>
                            <ul>
                                <li>Computerwartung (Software & Hardware)</li>
                                <li>Einrichtung von Computernetzwerken</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(10/1997 – 07/2000)</span></div>
                    </div>
                </div>
            </section>
            <hr className="m-0" />
        </>
    )
};

export default Erfahrungen;
